import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import useReadCookies from "../../hooks/useReadCookies";
import { getGroupsStatus } from '../../dashboard/dashboardSlice';
import { useTranslation } from 'react-i18next';

function ClassScore() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const cookieGameId = Cookies.get('game_id');

  let { cookieGroupId } = useReadCookies();
  //console.log(cookieGroupId);

  const groups = useSelector((state) => state.dashboard.groupStatus);

  useEffect(() => {
    dispatch(getGroupsStatus(cookieGameId));

    let interval = setInterval(() => {
      dispatch(getGroupsStatus(cookieGameId));
    }, 5000);

    return () => clearInterval(interval);
  }, []);



  return (
    <div className="score-container">
      <h2 className="score-title">{t("student.game_overview.teams_list_title")}</h2>
      <ol className="score-list">
        {groups &&
          groups.map((group, key) => (
            <li key={key} className={`group ${cookieGroupId == group.group_id ? 'my-group' : ''}`}>
              <div className="group-rank">{group.rank}</div>
              <div className={`group-card`} style={{ backgroundImage: `url('/storage/avatar/group_${group.group_id}.png')` }}></div>
            </li>
          ))}
      </ol>
    </div>
  )
}

export default ClassScore;